export const sources = {
	avif: "__VITE_ASSET__U2YZxvNlcnuoWcGKwa9Wsw__ 640w, __VITE_ASSET__m8R6TgWxwop2r_xOIPNRtg__ 960w, __VITE_ASSET__q6tfGKm3Qmt5DJmATeHQdA__ 1280w, __VITE_ASSET__tgFyw$X211zXSctfMU9_LA__ 1536w",
	webp: "__VITE_ASSET__epdbhdyBUyD3hvxx0_dcTg__ 640w, __VITE_ASSET__pADEGV0e5Qot5ZhzD_GrLg__ 960w, __VITE_ASSET__ykb1zIozoJBMq4UvQnlhcQ__ 1280w, __VITE_ASSET__LphhLScmzwPqWwTyAbd7ig__ 1536w",
	jpeg: "__VITE_ASSET__aLISaAY6NSiJFT$6GdtrfA__ 640w, __VITE_ASSET__Msg57USEadASvSStYSdmzA__ 960w, __VITE_ASSET__dJ$ULFcuzX43djbIEsCZPw__ 1280w, __VITE_ASSET__BjjUHagISQHtPWYmu3KuwQ__ 1536w"
};
export const img = {
	src: "__VITE_ASSET__BjjUHagISQHtPWYmu3KuwQ__",
	w: 1536,
	h: 1024
};
export default {
	sources: sources,
	img: img
};
